import { useEffect, useState } from 'react';

type TUseElementWidthReturn = {
  width: number;
};

export function useWindowWidth(selector?: string): TUseElementWidthReturn {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (selector) {
        const element = document.querySelector(selector);
        setWidth(element ? element.clientWidth : window.innerWidth);
      } else {
        setWidth(window.innerWidth);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [selector]);

  return { width };
}
